<template>
  <el-date-picker
    :type="props.config.type"
    :range-separator="$t('common.to')"
    :format="props.config.format"
    clearable
    :placeholder="$t(props.config?.label || '')"
    :style="{ width: '230px' }"
    v-bind="{ ...$attrs, ...props.config }"
    :start-placeholder="
      $t(props.config?.startPlaceholder || '') != ''
        ? $t(props.config?.startPlaceholder || '')
        : $t('common.startDate')
    "
    :end-placeholder="
      $t(props.config?.endPlaceholder || '') != ''
        ? $t(props.config?.endPlaceholder || '')
        : $t('common.endDate')
    "
  />
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "search-date",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  setup(props) {
    return {
      props
    };
  }
});
</script>
